import { createStore } from 'vuex'
export default createStore({
  state: {
   
    sourceUrl: '',
    requirementList: []
  },
  getters: {
  },
  mutations: {
    setRequirementList (state, obj) {
      state.requirementList = obj
    },
    setSourceUrl (state, url) {
      state.sourceUrl = url
    }

  },
  actions: {
  },
  modules: {
  }
})
